import React from "react";
import Select from "react-select";

import { Button, ButtonGroup, Toast } from "aible";

import { AutoSizer } from "react-virtualized";

import { Sankey, Tooltip } from "recharts";
import BalanceSankeyLink from "components/Optimizer/BalanceSankeyLink";
import BalanceSankeyNode from "components/Optimizer/BalanceSankeyNode";
import BalanceLegend from "components/UnifiedProject/Optimize/Double/BalanceLegend.js";
import BalancerPieChart from "components/UnifiedProject/Optimize/Double/BalancerPieChart";

import Toggle from "react-toggle";

import numeral from "numeral";

import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import PieChart from "components/Project/PieChart";
import TinyBarChart from "components/Project/TinyBarChart";

import ImpactSlider from "components/Optimizer/ImpactSlider";

import { BALANCER_OUTPUT, isSameSetup, translateColors } from "containers/Project/reducer";

import SankeyChart from "components/Optimizer/SankeyChart";

import styles from "./style.module.css";

// Returns true if `data` is safe to hand to recharts' <Sankey>.
// Rejects cycles, self-loops, out-of-range indices, and bad numeric values --
// all things that send the Sankey depth-assignment pass into infinite
// recursion and blow the stack.
function isSafeSankeyData(data) {
  console.log("is safe Sankey?? ", data);
  if (!data || !Array.isArray(data.nodes) || !Array.isArray(data.links)) {
    return false;
  }

  const nodeCount = data.nodes.length;
  if (nodeCount === 0) return false;

  const adjacency = data.nodes.map(() => []);
  for (const link of data.links) {
    const { source, target, value } = link;

    if (
      !Number.isInteger(source) ||
      !Number.isInteger(target) ||
      source < 0 ||
      target < 0 ||
      source >= nodeCount ||
      target >= nodeCount ||
      source === target
    ) {
      return false;
    }

    if (typeof value !== "number" || !Number.isFinite(value) || value < 0) {
      return false;
    }

    adjacency[source].push(target);
  }

  // Iterative DFS cycle detection via three-state coloring.
  // gray = currently on the recursion stack; hitting a gray node = back edge = cycle.
  // Done iteratively so the validator itself can't blow the stack on deep graphs.
  const WHITE = 0,
    GRAY = 1,
    BLACK = 2;
  const color = new Array(nodeCount).fill(WHITE);

  const stack = [];
  for (let start = 0; start < nodeCount; start++) {
    if (color[start] !== WHITE) continue;

    stack.push({ node: start, index: 0 });
    color[start] = GRAY;

    while (stack.length > 0) {
      const frame = stack[stack.length - 1];
      const neighbors = adjacency[frame.node];

      if (frame.index < neighbors.length) {
        const next = neighbors[frame.index++];
        if (color[next] === GRAY) return false; // back edge = cycle
        if (color[next] === WHITE) {
          color[next] = GRAY;
          stack.push({ node: next, index: 0 });
        }
      } else {
        color[frame.node] = BLACK;
        stack.pop();
      }
    }
  }

  return true;
}

export default class DoubleOptimize extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHammer: false,
      isHelpClosed: false,
      isDrivers: true
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderAssumptions() {
    const {
      id,
      setup,
      blueprint,
      optimizer,
      optimized,
      isContinuous,
      customMappings,
      toggleCustomMapping,
      modelGroups,
      updateBaselineCustomValue,
      updateCustomValue,
      updateDrilldownValue,
      canEditAssumptions,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateBaselineConversionGain,
      updateBaselineConversionCost,
      updateBaselineConversionMissed,
      updateBaselineConversionSaved
    } = this.props;

    console.log("double balancer, setup", setup);

    if (setup === undefined || Object.keys(setup).length === 0) {
      return <div />;
    }

    const isOverallSegment = this.getIsOverallSegment();

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = hasCustomValues;

    return isOverallSegment ? (
      <div>
        <div className={styles.shareHeader}>
          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
            {"Assumptions"}
          </div>
          <div className={styles.costSectionTwo}>{"Distribution"}</div>
          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
            {"Average"}
          </div>
        </div>
        {showCustomValues ? (
          <div
            className={styles.oItemBotContent}
            style={{
              marginTop: "0px"
            }}
          >
            <div className={styles.aholder}>
              {Object.keys(optimized.setup.customValues).map((c, i) => {
                const bpDesc =
                  optimized &&
                  optimized.blueprint &&
                  optimized.blueprint &&
                  optimized.blueprint.wizard &&
                  optimized.blueprint.wizard.customFields &&
                  optimized.blueprint.wizard.customFields[c] &&
                  optimized.blueprint.wizard.customFields[c].desc
                    ? optimized.blueprint.wizard.customFields[c].desc
                    : c;

                return (
                  <div key={i} className={styles.assumptionItem}>
                    <div className={styles.costSectionOne} title={bpDesc}>
                      {c}
                    </div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.customValues[c],
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.customValues[c]}
                        drilldownValue={optimizer.drilldownValue}
                        updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.customValues[c] !== undefined
                        ? Number(optimized.setup.customValues[c]).toFixed(2)
                        : ""}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            {modelGroups && modelGroups.drilldownValues && (
              <div
                className={styles.oItemBotContent}
                style={{
                  marginTop: "0px"
                }}
              >
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionGain,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionGain}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionGain !== undefined
                      ? Number(optimized.setup.conversionGain).toFixed(2)
                      : ""}
                  </div>
                </div>
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionCost,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionCost}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionCost !== undefined
                      ? Number(optimized.setup.conversionCost).toFixed(2)
                      : ""}
                  </div>
                </div>
                {!isContinuous ? (
                  <React.Fragment>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionSaved,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionSaved}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionSaved !== undefined
                          ? Number(optimized.setup.conversionSaved).toFixed(2)
                          : ""}
                      </div>
                    </div>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionGain,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionMissed}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionMissed !== undefined
                          ? Number(optimized.setup.conversionMissed).toFixed(2)
                          : ""}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )}
      </div>
    ) : (
      <div>
        {optimized ? (
          <div className={styles.aHeader}>
            <div style={{ width: "50%" }}>{"Assumptions"}</div>
            <div style={{ width: "50%" }}>{"Scenario"}</div>
          </div>
        ) : (
          <div className={styles.aHeader}>
            <div style={{ width: "50%" }}>{"Assumptions"}</div>
            <div style={{ width: "50%" }}>{"Scenario"}</div>
          </div>
        )}
        <div className={styles.aHolder}>
          {Object.keys(setup.customValues).map((v, i) => {
            const bpDesc =
              blueprint &&
              blueprint &&
              blueprint.wizard &&
              blueprint.wizard.customFields &&
              blueprint.wizard.customFields[v] &&
              blueprint.wizard.customFields[v].desc
                ? blueprint.wizard.customFields[v].desc
                : v;

            const currMapping = customMappings && customMappings[v];

            return (
              <React.Fragment key={v + i}>
                <div className={styles.assumptionEditItem}>
                  <div
                    className={styles.costEditThirdsOne}
                    title={bpDesc}
                    style={optimized === undefined ? { width: "50%" } : {}}
                  >
                    {v}
                  </div>
                  {/*
									<div
										className={styles.costEditThirdsTwo}
										style={
											optimized === undefined
												? { width: "50%" }
												: {}
										}
									>
										<div className={styles.cFieldInput}>
											<LineInput
												isMediumBox
												onChange={(val) =>
													updateBaselineCustomValue(
														retId,
														setup.blueprintId,
														v,
														val
													)
												}
												value={
													setup.baselineCustomValues &&
													setup.baselineCustomValues[
														v
													] !== undefined
														? setup
																.baselineCustomValues[
																v
														  ]
														: setup.customValues[v]
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
									</div>
									*/}
                  <div className={styles.costEditThirdsThree}>
                    <div className={styles.cFieldInput}>
                      <LineInput
                        isMediumBox
                        onChange={(val) => updateCustomValue(retId, setup.blueprintId, v, val)}
                        value={setup.customValues[v]}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}

          {Object.keys(setup.customValues).length === 0 ? (
            <div>
              <div className={styles.assumptionEditItem}>
                <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                  {setup.truePositiveLabel}
                </div>
                {/*
								<div
									className={styles.costEditThirdsTwo}
									style={
										optimized === undefined
											? { width: "50%" }
											: {}
									}
								>
									<LineInput
										isMediumBox
										value={
											setup.baselineConversionGain !==
											undefined
												? setup.baselineConversionGain
												: setup.conversionGain
										}
										onChange={(val) =>
											updateBaselineConversionGain(
												retId,
												val
											)
										}
										style={{ color: "#4B495B" }}
									/>
								</div>
								*/}
                <div className={styles.costEditThirdsThree}>
                  <LineInput
                    isMediumBox
                    value={setup.conversionGain}
                    onChange={(val) => updateConversionGain(retId, val)}
                    style={{ color: "#4B495B" }}
                  />
                </div>
              </div>
              <div className={styles.assumptionEditItem}>
                <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                  {setup.falsePositiveLabel}
                </div>
                {/*
								<div
									className={styles.costEditThirdsTwo}
									style={
										optimized === undefined
											? { width: "50%" }
											: {}
									}
								>
									<LineInput
										isMediumBox
										value={
											setup.baselineConversionCost !==
											undefined
												? setup.baselineConversionCost
												: setup.conversionCost
										}
										onChange={(val) =>
											updateBaselineConversionCost(
												retId,
												val
											)
										}
										style={{ color: "#4B495B" }}
									/>
								</div>
								*/}

                <div className={styles.costEditThirdsThree}>
                  <LineInput
                    isMediumBox
                    value={setup.conversionCost}
                    onChange={(val) => updateConversionCost(retId, val)}
                    style={{ color: "#4B495B" }}
                  />
                </div>
              </div>
              {!isContinuous ? (
                <React.Fragment>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.trueNegativeLabel}
                    </div>
                    {/*
										<div
											className={styles.costEditThirdsTwo}
											style={
												optimized === undefined
													? { width: "50%" }
													: {}
											}
										>
											<LineInput
												isMediumBox
												value={
													setup.baselineConversionSaved !==
													undefined
														? setup.baselineConversionSaved
														: setup.conversionSaved
												}
												onChange={(val) =>
													updateBaselineConversionSaved(
														retId,
														val
													)
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
										*/}

                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionSaved}
                        onChange={(val) => updateConversionSaved(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.falseNegativeLabel}
                    </div>
                    {/*
									<div
										className={styles.costEditThirdsTwo}
										style={
											optimized === undefined
												? { width: "50%" }
												: {}
										}
									>
										<LineInput
											isMediumBox
											value={
												setup.baselineConversionMissed !==
												undefined
													? setup.baselineConversionMissed
													: setup.conversionMissed
											}
											onChange={(val) =>
												updateBaselineConversionMissed(
													retId,
													val
												)
											}
											style={{ color: "#4B495B" }}
										/>
									</div>
									*/}

                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionMissed}
                        onChange={(val) => updateConversionMissed(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  renderProgress(label) {
    const { optimized } = this.props;

    return (
      <div className={styles.eLight}>
        <div className={styles.lFlex}>
          <div className={styles.eCircle} />
          {optimized && optimized.isCreating ? "Finding Optimal " + label : "Optimization Not Started"}
        </div>
        <div className={styles.eLightBar} />
      </div>
    );
  }

  renderMix() {
    const { project, createSplits, optimized, optimizer, modelGroups, linkedModelGroups, balanceData } = this.props;

    const isOverallSegment = this.getIsOverallSegment();

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    const upstreamData =
      linkedModelGroups && linkedModelGroups.drilldownValues
        ? linkedModelGroups.drilldownValues
            .filter((s, i, sList) => s.value !== "Overall" || sList.length === 1)
            .map((s) => ({
              name: s.value,
              runId: s.runId,
              value: Math.round(
                s.optimalPct *
                  (!isOverallSegment &&
                  balanceData &&
                  balanceData[optimized.segmentId] &&
                  balanceData[optimized.segmentId][s.runId]
                    ? balanceData[optimized.segmentId][s.runId].percentage / 100
                    : 1)
              ),
              color: translateColors(s.color),
              isOutline: true
            }))
        : [];

    const downstreamData = otherSlices
      ? otherSlices
          .map((s) => ({
            name: s.value,
            runId: s.runId,
            value: Math.round(s.optimalPct),
            color: s.color
          }))
          .filter((s) => isOverallSegment || s.runId === optimized.innerId)
      : [];

    const pieData = [...upstreamData, ...downstreamData].filter((d) => d.value !== 0);

    const total = pieData.reduce((a, b) => a + b.value, 0);

    if (!pieData.find((e) => e.value)) {
      return <div className={styles.mixHolder} style={{ overflow: "visible" }}></div>;
    }

    return (
      <div className={styles.balanceHolder}>
        <div className={styles.balanceLegend + " " + styles.left}>
          <BalanceLegend pData={upstreamData} total={total} reverse />
        </div>
        <div className={styles.balancePie}>
          <BalancerPieChart pData={pieData} unit={optimized.unitLabelShort} />
        </div>
        <div className={styles.balanceLegend + " " + styles.right}>
          <BalanceLegend pData={downstreamData} total={total} />
        </div>
      </div>
    );
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  renderSankey() {
    const { optimized } = this.props;

    return optimized && optimized.isLinkedProjectLoading ? <LoadingIndicator /> : <SankeyChart optimized={optimized} />;
  }

  getLabels() {
    const { optimized } = this.props;

    if (
      optimized === undefined ||
      optimized.first === undefined ||
      optimized.first.setup === undefined ||
      optimized.second === undefined ||
      optimized.second.setup === undefined
    ) {
      return {};
    }

    const fSetup = optimized.first.setup;
    const fTransactionLabel = fSetup.transactionLabel ? fSetup.transactionLabel : "Leads";
    const fNotPursuedTransactionLabel = fSetup.notPursuedTransactionLabel
      ? fSetup.notPursuedTransactionLabel
      : "Potential " + fTransactionLabel;
    const fTrueAction = fSetup.trueAction ? fSetup.trueAction : "Pursue";
    const fFalseAction = fSetup.falseAction ? fSetup.falseAction : "Ignore";

    const sSetup = optimized.second.setup;
    const sTransactionLabel = sSetup.transactionLabel ? sSetup.transactionLabel : "Opportunities";
    const sNotPursuedTransactionLabel = sSetup.notPursuedTransactionLabel
      ? sSetup.notPursuedTransactionLabel
      : "Potential " + sTransactionLabel;
    const sTrueAction = sSetup.trueAction ? sSetup.trueAction : "Pursue";
    const sFalseAction = sSetup.falseAction ? sSetup.falseAction : "Ignore";

    return {
      fTransactionLabel,
      fNotPursuedTransactionLabel,
      fTrueAction,
      fFalseAction,
      fTruePositive: fSetup.truePositiveLabel,
      sTransactionLabel,
      sNotPursuedTransactionLabel,
      sTrueAction,
      sFalseAction,
      sTruePositive: sSetup.truePositiveLabel
    };
  }

  renderTopSankey() {
    const { optimized, project, linkedProject, linkedProjectOutputMode, next, linkedNext } = this.props;

    const labels = this.getLabels();

    if (optimized === undefined || optimized.first === undefined || optimized.second === undefined) {
      return <div />;
    }

    let linkedProjectOutputLabel, linkedProjectOutputValue;
    switch (linkedProjectOutputMode) {
      case BALANCER_OUTPUT.TRUE_POSITIVE:
        linkedProjectOutputLabel = labels.fTruePositive;
        linkedProjectOutputValue = optimized.first.totalWon;
        break;
      case BALANCER_OUTPUT.ALL_POSITIVE:
      default:
        linkedProjectOutputLabel = labels.fTransactionLabel + " you " + labels.fTrueAction;
        linkedProjectOutputValue = optimized.first.totalPursued;
        break;
    }

    return (
      <div className={styles.sankeyTop}>
        <div className={styles.sMsg}>{"Optimized Pipeline"}</div>
        <div className={styles.sankeyBot}>
          <div className={styles.sankeyLeft + " " + styles.sankeyPointer}>
            <div className={styles.sankeyContent + " " + styles.sankeyTitle} style={{ height: "40px" }}>
              {linkedProject && (linkedNext?.reportLabel ?? linkedProject.name)}
            </div>
            <div className={styles.sankeyContent} style={{ height: "60px" }}>
              <div className={styles.sItem}>
                <div className={styles.sTop}>{numeral(optimized.first.totalProspects).format("0.0a")}</div>
                <div className={styles.sBot}>{labels.fTransactionLabel}</div>
              </div>
              <div className={styles.sItem}>
                <div className={styles.sTop}>
                  {numeral(optimized.first.totalProspects - optimized.first.totalPursued).format("0.0a")}
                </div>
                <div className={styles.sBot}>{labels.fTransactionLabel + ": " + labels.fFalseAction}</div>
              </div>
              <div className={styles.sItem}>
                <div className={styles.sTop}>{numeral(linkedProjectOutputValue).format("0.0a")}</div>
                <div className={styles.sBot}>{linkedProjectOutputLabel}</div>
              </div>
            </div>
          </div>
          <div className={styles.sankeyRight + " " + styles.sankeyPointer}>
            <div className={styles.sankeyContent + " " + styles.sankeyTitle} style={{ height: "40px" }}>
              {next?.reportLabel ?? project?.name}
            </div>
            <div className={styles.sankeyContent} style={{ height: "60px" }}>
              <div className={styles.sItem}>
                <div className={styles.sTop}>{numeral(optimized.first.totalAllocated).format("0.0a")}</div>
                <div className={styles.sBot}>{"Potential " + labels.sTransactionLabel}</div>
              </div>
              <div className={styles.sItem}>
                <div className={styles.sTop}>{numeral(optimized.second.totalPursued).format("0.0a")}</div>
                <div className={styles.sBot}>{labels.sTransactionLabel + ": " + labels.sTrueAction}</div>
              </div>
              <div className={styles.sItem}>
                <div className={styles.sTop}>{numeral(optimized.second.totalWon).format("0.0a")}</div>
                <div className={styles.sBot}>{labels.sTruePositive}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getSankeyData() {
    const { project, linkedProject, modelGroups, optimized, balanceData, balanceAlloc, reports } = this.props;

    const IGNORE_COLOR = "#C8CAD4";
    const TRUE_COLOR = "#54C06C";
    const FALSE_COLOR = "#C03E5A";

    const ignoreAction =
      optimized && optimized.setup && optimized.setup.falseAction ? optimized.setup.falseAction : "Ignore";

    const truePositiveAction =
      optimized && optimized.setup && optimized.setup.truePositiveLabel
        ? optimized.setup.truePositiveLabel
        : "True Positive";

    const falsePositiveAction =
      optimized && optimized.setup && optimized.setup.falsePositiveLabel
        ? optimized.setup.falsePositiveLabel
        : "False Positive";

    const finalValues =
      optimized && optimized.setup
        ? [
            { key: truePositiveAction, name: truePositiveAction, color: TRUE_COLOR },
            { key: falsePositiveAction, name: falsePositiveAction, color: FALSE_COLOR },
            { key: ignoreAction, name: ignoreAction, color: IGNORE_COLOR }
          ]
        : [];
    // Each node gets a unique `key`. Non-outline (current-project) nodes key
    // on the plain segment name; outline (linked-project) nodes key with an
    // "__outline__" prefix so same-named segments on the two sides don't
    // collapse to one index and create a false cycle. `name` is what the user
    // sees and now carries a project-scoped prefix to make origin obvious.
    const names =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues
            .filter((s) => s && s.segment && (this.getIsOverallSegment() || optimized.innerId === s.runId))
            .map((s) => ({
              key: s.segment.name,
              name: s.segment.name,
              color: s.color,
              runId: s.runId
            }))
            .concat(
              linkedProject && linkedProject.segments
                ? linkedProject.segments
                    .filter((s) => s.conditions && s.conditions.length > 0)
                    .map((s, i) => {
                      return {
                        key: `__outline__${s.name}`,
                        name: s.name,
                        color: translateColors(undefined, i + 1),
                        runId: s.job.job_id,
                        isOutline: true
                      };
                    })
                : []
            )
            .concat(finalValues)
        : [];

    const namesHelper = {};
    const links = [];

    if (balanceAlloc && this.getIsOverallSegment() && false) {
      Object.keys(balanceAlloc)
        .filter((k) => balanceAlloc[k].total !== balanceAlloc[k].used)
        .map((k) => balanceAlloc[k])
        .forEach((b) => {
          const linkValue = b.total - b.used;
          if (linkValue !== 0) {
            namesHelper[b.segment.name] = true;
            namesHelper[ignoreAction] = true;
            links.push({
              source: b.segment.name,
              target: ignoreAction,
              value: linkValue,
              color: IGNORE_COLOR
            });
          }
        });
    }

    modelGroups &&
      modelGroups.drilldownValues
        .filter((s) => this.getIsOverallSegment() || optimized.innerId === s.runId)
        .forEach((s) => {
          const scm =
            project &&
            project.settings &&
            project.settings.segmentConfusionMatrices &&
            project.settings.segmentConfusionMatrices[s.segmentId]
              ? project.settings.segmentConfusionMatrices[s.segmentId]
              : undefined;

          if (scm) {
            const trueLinkValue = Math.round(scm.tp);
            if (trueLinkValue !== 0) {
              namesHelper[s.segment.name] = true;
              namesHelper[truePositiveAction] = true;
              links.push({
                source: s.segment.name,
                target: truePositiveAction,
                value: trueLinkValue,
                color: TRUE_COLOR
              });
            }

            const falseLinkValue = Math.round(scm.fp);
            if (falseLinkValue !== 0) {
              namesHelper[s.segment.name] = true;
              namesHelper[falsePositiveAction] = true;
              links.push({
                source: s.segment.name,
                target: falsePositiveAction,
                value: falseLinkValue,
                color: FALSE_COLOR
              });
            }

            const ignoreLinkValue = Math.round(scm.tn + scm.fn);
            if (ignoreLinkValue !== 0) {
              namesHelper[s.segment.name] = true;
              namesHelper[ignoreAction] = true;
              links.push({
                source: s.segment.name,
                target: ignoreAction,
                value: ignoreLinkValue,
                color: IGNORE_COLOR
              });
            }
          }

          if (s.segmentId && balanceData && balanceData[s.segmentId] !== undefined) {
            Object.keys(balanceData[s.segmentId])
              .filter((b) => balanceData[s.segmentId][b] && balanceData[s.segmentId][b].linkedSegment)
              .forEach((b) => {
                const linkValue = balanceData[s.segmentId][b].total;

                if (linkValue !== 0) {
                  // Source of a balance link comes from the LINKED project, so
                  // it resolves to the outline-keyed node.
                  const linkedOutlineKey = `__outline__${balanceData[s.segmentId][b].linkedSegment.name}`;

                  namesHelper[linkedOutlineKey] = true;
                  namesHelper[s.segment.name] = true;
                  links.push({
                    source: linkedOutlineKey,
                    target: s.segment.name,
                    value: linkValue,
                    color: s.color
                  });
                }
              });
          }
        });

    // Filter to only nodes that have links, then remap link source/target
    // from keys to indices.
    const retNames = names.filter((n) => namesHelper[n.key]);
    const nIndex = retNames.map((n) => n.key);
    const retLinks = links
      .map((link) => {
        return {
          ...link,
          source: nIndex.indexOf(link.source),
          target: nIndex.indexOf(link.target)
        };
      })
      .filter((l) => l.source !== -1 && l.target !== -1);

    const data = {
      nodes: retNames,
      links: retLinks
    };

    return data;
  }

  getColoredData = (data) => {
    const { isCheckBalance, checkBalance } = this.props;

    if (!isCheckBalance || !checkBalance?.highestSubgroup?.runId) {
      return data;
    }

    const targetRunId = checkBalance.highestSubgroup.runId;

    // 1. Find target node indices
    const targetIndices = data.nodes.map((n, i) => (n.runId === targetRunId ? i : -1)).filter((i) => i !== -1);

    if (!targetIndices.length) return data;

    const inputs = new Set(); // nodes flowing INTO target
    const outputs = new Set(); // nodes flowing OUT of target

    // 2. Find direct inputs + outputs
    data.links.forEach((link) => {
      if (targetIndices.includes(link.target)) {
        inputs.add(link.source);
      }
      if (targetIndices.includes(link.source)) {
        outputs.add(link.target);
      }
    });

    // 3. Build allowed node set
    const activeNodes = new Set([...targetIndices, ...inputs, ...outputs]);

    // 4. Filter links (IMPORTANT: only keep desired paths)
    const newLinks = data.links.map((link) => {
      const isInputLink = targetIndices.includes(link.target) && inputs.has(link.source);

      const isOutputLink = targetIndices.includes(link.source) && outputs.has(link.target);

      const isActive = isInputLink || isOutputLink;

      return {
        ...link,
        color: isActive ? "#FF4D4F" : "#E0E0E0",
        opacity: isActive ? 1 : 0.2
      };
    });

    // 5. Color nodes
    const newNodes = data.nodes.map((node, i) => ({
      ...node,
      color: activeNodes.has(i) ? "#FF4D4F" : "#D3D3D3",
      opacity: activeNodes.has(i) ? 1 : 0.4
    }));

    return {
      ...data,
      nodes: newNodes,
      links: newLinks
    };
  };

  renderAllocationSankey() {
    const { project, linkedProject, modelGroups, optimized, balanceData, isCheckBalance, checkBalance } = this.props;

    const fData = this.getSankeyData();
    const data = this.getColoredData(fData);

    if (
      (data && data.links && data.links.filter((l) => l.value !== 0).length === 0 && this.getIsOverallSegment()) ||
      (data && data.names && data.names.length === 0) ||
      !(project && project.segments && project.segments.length > 1)
    ) {
      return <div />;
    }

    if (data && data.links && data.links.filter((l) => l.value !== 0).length === 0) {
      return (
        <div className={styles.allocSankey}>
          <div className={styles.allocMessage} style={{ marginTop: "20px" }}>
            {this.allocationRef ? (
              <a
                onClick={() =>
                  this.allocationRef.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  })
                }
              >
                {"Allocate resourcing below"}
              </a>
            ) : (
              "Allocate resourcing below"
            )}
          </div>
        </div>
      );
    }

    if (data && data.links) {
      const currentLinks = data.links;
      const newLinks = currentLinks.map((link) => ({
        color: link.color,
        source: link.source,
        target: link.target,
        value: Math.round(link.value)
      }));
      data.links = newLinks;
    }

    if (!isSafeSankeyData(data)) {
      console.warn("renderAllocationSankey: unsafe sankey data, skipping render", data);
      return <div />;
    }

    return (
      <div className={styles.allocSankey} key={optimized && optimized.innerId ? optimized.innerId : "wat"}>
        <AutoSizer>
          {({ width, height }) => (
            <Sankey
              data={data}
              nodeWidth={20}
              nodePadding={100}
              margin={{
                left: 20,
                right: 20,
                top: 20,
                bottom: 20
              }}
              linkCurvature={0.5}
              iterations={64}
              link={<BalanceSankeyLink />}
              node={<BalanceSankeyNode containerWidth={width - 100} />}
              height={height}
              width={width}
              sort={false}
            >
              <defs>
                <linearGradient id={"falseGradient"}>
                  <stop offset="0%" stopColor="rgba(225, 227, 232, 1)" />
                  <stop offset="100%" stopColor="rgba(225, 227, 232, 1)" />
                </linearGradient>
                <linearGradient id={"trueGradient"}>
                  <stop offset="0%" stopColor="rgba(126, 105, 215, 0.3)" />
                  <stop offset="100%" stopColor="rgba(97, 68, 153, 0.5)" />
                </linearGradient>
              </defs>
              <Tooltip />
            </Sankey>
          )}
        </AutoSizer>
      </div>
    );
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const truePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.truePositive)
        : Number(setup.truePositive);
    const falsePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falsePositive)
        : Number(setup.falsePositive);
    const trueNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.trueNegative)
        : Number(setup.trueNegative);
    const falseNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falseNegative)
        : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  renderProjectSelect() {
    const {
      id,
      isNext,
      approvedScenario,
      isContinuous,
      getIsContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      isBalance,
      hasLinkedProject,
      linkedProject,
      isOptimizerWithinBounds,
      linkedProjectOutputModeOption,
      linkedProjectOutputModeOptions,
      isLoadingLink,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      linkProjectOptions,
      setMaxBudget,
      setMinBudget,
      updateLinkedProjectId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateHasLinkedProject,
      updateNetImpactLabel,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      updateLinkedScenarioId,
      updateLinkedProjectOutputMode,
      history,
      goToBalance,
      linkedNext,
      isChatGPT
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    return (
      <div>
        {optimized ? (
          <div
            className={styles.eBotItem}
            style={
              isNext
                ? { margin: "20px" }
                : isChatGPT
                  ? { marginTop: "20px", marginBottom: "20px" }
                  : { marginTop: "20px" }
            }
          >
            <div
              className={styles.aHeader}
              style={
                hasLinkedProject
                  ? {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                      paddingBottom: "20px",
                      marginBottom: "20px"
                    }
                  : {}
              }
            >
              <div
                style={{
                  width: "calc(100% - 75px"
                }}
              >
                {"Is there another project that impacts the input or resourcing for this project?"}
              </div>
              <div style={{ width: "100px" }}>
                <div id={"eToggle"} className={styles.tHolder}>
                  <Toggle
                    checked={hasLinkedProject === true}
                    icons={false}
                    onChange={(e) => updateHasLinkedProject(!hasLinkedProject)}
                  />
                  <span className={hasLinkedProject === true ? styles.yPos : styles.nPos}>
                    {hasLinkedProject === true ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>
            {hasLinkedProject && (
              <Select
                options={linkProjectOptions}
                value={
                  optimized.setup && optimized.setup.linkedProjectId !== undefined
                    ? linkProjectOptions.find((option) => {
                        return option.value === optimized.setup.linkedProjectId;
                      })
                    : {
                        label: "Select a project...",
                        value: undefined
                      }
                }
                menuPlacement={isNext ? "bottom" : "top"}
                onChange={(val) => updateLinkedProjectId(val.value)}
              />
            )}
            {hasLinkedProject && linkedProject && (
              <div className={styles.sSelect}>
                {isLoadingLink ? (
                  <div className={styles.loadScenario}>
                    <div>{"Loading Project...."}</div>
                    <LoadingIndicator
                      style={{
                        margin: "0px"
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <div>{"Select a scenario"}</div>
                    <Select
                      options={
                        linkedProject && linkedProject.settings && linkedProject.settings.originalScenarios
                          ? linkedProject.settings.originalScenarios.map((s) => ({
                              label: s.name,
                              value: s.id
                            }))
                          : []
                      }
                      value={
                        optimized.setup.linkedScenarioId !== undefined &&
                        optimized.setup.linkedScenarioId !== "Default Scenario"
                          ? linkedProject.settings &&
                            linkedProject.settings.originalScenarios &&
                            linkedProject.settings.originalScenarios.filter(
                              (s) => s.id === optimized.setup.linkedScenarioId
                            ).length > 0
                            ? {
                                label: linkedProject.settings.originalScenarios.filter(
                                  (s) => s.id === optimized.setup.linkedScenarioId
                                )[0].name,
                                value: optimized.setup.linkedScenarioId
                              }
                            : {}
                          : {
                              label: "Default Scenario",
                              value: "Default Scenario"
                            }
                      }
                      onChange={(val) => updateLinkedScenarioId(val.value)}
                      isDisabled={
                        !(
                          linkedProject &&
                          linkedProject.settings &&
                          linkedProject.settings.originalScenarios &&
                          linkedProject.settings.originalScenarios.length
                        )
                      }
                    />
                    <div
                      style={{
                        marginTop: "20px"
                      }}
                    >
                      {"Select the output of " + (linkedNext?.reportLabel ?? linkedProject.name)}
                    </div>
                    <Select
                      options={linkedProjectOutputModeOptions}
                      value={linkedProjectOutputModeOption}
                      onChange={({ label, value }) => updateLinkedProjectOutputMode(value)}
                    />
                    <div className={styles.balanceButtonHolder}>
                      {/* <Button
												type={"primary"}
												onClick={() => goToBalance()}
												disabled={getIsContinuous(
													optimized.setup
														.linkedProjectId
												)}
											>
												{getIsContinuous(
													optimized.setup
														.linkedProjectId
												)
													? "Select a Categorical Project to Balance"
													: "Balance Projects"}
											</Button> */}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  // Uses subgroup counts to make overall counts if overall
  getCounts(isBaseline = false) {
    const { setup, modelGroups } = this.props;
    if (!this.getIsOverallSegment()) {
      const countsObj = isBaseline && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts : setup;
      return {
        truePositive: Number(countsObj.truePositive),
        falsePositive: Number(countsObj.falsePositive),
        trueNegative: Number(countsObj.trueNegative),
        falseNegative: Number(countsObj.falseNegative)
      };
    }
    const retCounts = {
      truePositive: 0,
      falsePositive: 0,
      trueNegative: 0,
      falseNegative: 0
    };
    modelGroups.drilldownValues
      .filter((d) => d.value !== "Overall")
      .map((d) => d.setup)
      .forEach((currSetup) => {
        const countsObj =
          isBaseline && currSetup.isRealityHammer && currSetup.baselineCounts ? currSetup.baselineCounts : currSetup;
        retCounts.truePositive = retCounts.truePositive + Number(countsObj.truePositive);
        retCounts.falsePositive = retCounts.falsePositive + Number(countsObj.falsePositive);
        retCounts.trueNegative = retCounts.trueNegative + Number(countsObj.trueNegative);
        retCounts.falseNegative = retCounts.falseNegative + Number(countsObj.falseNegative);
      });
    return retCounts;
  }

  renderSplitSetup() {
    const {
      id,
      optimized,
      project,
      balanceAlloc,
      updateLinkedSubgroup,
      modelGroups,
      linkedProject,
      updateLinkedRunId,
      hasLinkedProject,
      goToOptimize,
      linkedNext
    } = this.props;

    const { addLink } = this.state;

    console.log("linked stuff", this.props);

    const isOverallSegment = this.getIsOverallSegment();

    // const options =
    // 	linkedProject && linkedProject.segments
    // 		? linkedProject.segments
    // 				.filter(
    // 					(s) =>
    // 						linkedProject.segments.length === 1 ||
    // 						s.conditions.length > 0
    // 				)
    // 				.map((s) => ({
    // 					label:
    // 						s.conditions.length > 0
    // 							? s.conditions[0].value
    // 							: s.assumption.data.label,
    // 					value: s.job.job_id,
    // 					segment: s,
    // 					setup: {},
    // 					linkedRuns:
    // 						modelGroups && modelGroups.drilldownValues
    // 							? modelGroups.drilldownValues
    // 									.filter(
    // 										(d) =>
    // 											d.setup &&
    // 											d.setup.linkedRuns &&
    // 											Object.keys(
    // 												d.setup.linkedRuns
    // 											).filter(
    // 												(k) =>
    // 													d.setup.linkedRuns[
    // 														k
    // 													] &&
    // 													d.setup.linkedRuns[
    // 														k
    // 													].linkedRunId ===
    // 														s.job.job_id
    // 											).length > 0
    // 									)
    // 									.map(
    // 										(d) =>
    // 											Object.keys(
    // 												d.setup.linkedRuns
    // 											)
    // 												.filter(
    // 													(k) =>
    // 														d.setup
    // 															.linkedRuns[
    // 															k
    // 														] &&
    // 														d.setup
    // 															.linkedRuns[
    // 															k
    // 														]
    // 															.linkedRunId ===
    // 															s.job.job_id
    // 												)
    // 												.map((k) => ({
    // 													id: k,
    // 													data: {
    // 														...d.setup
    // 															.linkedRuns[
    // 															k
    // 														],
    // 														fromRunId:
    // 															d.runId,
    // 														fromRunLabel:
    // 															d.value,
    // 													},
    // 												}))[0]
    // 									)
    // 							: [],
    // 				}))
    // 		: [];

    // const fOptions =
    // 	modelGroups && modelGroups.drilldownValues
    // 		? modelGroups.drilldownValues.map((d) => ({
    // 				label: d.value,
    // 				value: d.runId,
    // 		  }))
    // 		: [];

    // const data = this.getSankeyData();

    return (
      <div className={styles.splitSetup}>
        {this.renderProjectSelect()}
        {hasLinkedProject && linkedProject !== undefined && (
          <div>
            <div className={styles.eBotHeader} style={{ paddingLeft: "20px", fontWeight: "bold" }}>
              {"Subgroup Allocation"}
            </div>
            <div className={styles.botFlex}>
              <div className={styles.botTotal}>
                <div className={styles.bSegmentTitle} />
                {balanceAlloc &&
                  Object.keys(balanceAlloc).map((b, i) => {
                    const pData =
                      balanceAlloc[b] && balanceAlloc[b].nUsed
                        ? balanceAlloc[b].nUsed
                            .map((d) => ({
                              name: d.toSegment.name,
                              value: d.percentage / 100,
                              color: d.color
                            }))
                            .concat([
                              {
                                name: "Unallocated",
                                value: Math.max(
                                  0,
                                  balanceAlloc[b].nUsed.reduce((a, b) => a - b.percentage / 100, 1)
                                ),
                                color: "rgb(204, 204, 204)"
                              }
                            ])
                            .filter((d) => d.value !== 0)
                        : [];

                    return (
                      <div className={styles.bChart} key={i}>
                        <div
                          style={{
                            fontWeight: "bold"
                          }}
                        >
                          {balanceAlloc[b].segment.name}
                        </div>
                        <div>{"Total: " + Math.round(balanceAlloc[b].total)}</div>
                        <div
                          style={{
                            width: "300px",
                            height: "100px"
                          }}
                        >
                          <PieChart secondaryColors pData={pData} onClick={() => {}} unit={"%"} />
                        </div>
                      </div>
                    );
                  })}
              </div>
              {isOverallSegment ? (
                <div className={styles.allocMessage}>{"Select a subgroup to allocate"}</div>
              ) : (
                <div className={styles.sBody}>
                  {modelGroups && modelGroups.drilldownValues ? (
                    modelGroups.drilldownValues
                      .filter((d) => modelGroups.drilldownValues.length === 1 || d.value !== "Overall")
                      .filter((d) => d.runId === optimized.innerId)
                      .map((d, i) => (
                        <div className={styles.bSegment} key={i}>
                          <div className={styles.bSegmentTitle}>
                            <div className={styles.flexItem}>
                              <span
                                className={styles.eCircle}
                                style={{
                                  background: d.color
                                }}
                              />
                              {d.label}
                            </div>
                            <div className={styles.bExplain}>
                              <span>
                                {"Enter resource percentage for "}
                                <span
                                  style={{
                                    fontWeight: "bold"
                                  }}
                                >
                                  {d.value}
                                </span>
                                <span>{" from linked project "}</span>
                                <span
                                  style={{
                                    fontWeight: "bold"
                                  }}
                                >
                                  {linkedProject ? (linkedNext?.reportLabel ?? linkedProject.name) : ""}
                                </span>
                                <span>{" subgroups "}</span>
                              </span>
                            </div>
                          </div>
                          {d.setup.linkedRuns !== undefined &&
                            Object.keys(d.setup.linkedRuns)
                              .filter((sId) => d.setup.linkedRuns[sId] !== undefined)
                              .map((sId) => (
                                <div className={styles.bSubOptions + " " + styles.bChart} key={sId}>
                                  <div className={styles.bInputLine}>
                                    <div
                                      style={{
                                        flex: "0 0 50px",
                                        marginRight: "4px",
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <LineInput
                                        isMediumBox
                                        value={d.setup.linkedRuns[sId].percentage || 0}
                                        onChange={(val) => updateLinkedSubgroup(d.runId, sId, undefined, val)}
                                      />
                                      <span
                                        style={{
                                          fontSize: "16px",
                                          marginLeft: "-4px"
                                        }}
                                      >
                                        {"%"}
                                      </span>
                                    </div>
                                    <div className={styles.bDesc}>
                                      <span>{" of "}</span>
                                      <strong>
                                        {balanceAlloc[sId].segment.conditions
                                          .map((c) => c.column + ": " + c.value)
                                          .join(", ") +
                                          " " +
                                          balanceAlloc[sId].segment.assumption.data.truePositiveLabel}
                                      </strong>
                                      <span>{" goes to "}</span>
                                      <strong>{d.value}</strong>
                                      <span>
                                        {" (" +
                                          Math.round(
                                            (d.setup.linkedRuns[sId].percentage / 100) * balanceAlloc[sId].total
                                          ) +
                                          " of " +
                                          Math.round(balanceAlloc[sId].total) +
                                          ")"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>
                      ))
                  ) : (
                    <div />
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderIsLoadingLink() {
    return (
      <div className={styles.loading}>
        {"Loading Linked Project..."}
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    );
  }

  getScaledLinkedOptimized(oKey) {
    const { linkedOptimized, modelGroups, balanceAlloc, optimized } = this.props;
    if (this.getIsOverallSegment()) {
      return linkedOptimized ? linkedOptimized[oKey] : 0;
    }
    let allocated = 0;
    let total = 0;
    if (modelGroups && modelGroups.drilldownValues) {
      modelGroups.drilldownValues
        .filter((d) => modelGroups.drilldownValues.length === 1 || d.value !== "Overall")
        .filter((d) => d.runId === optimized.innerId)
        .forEach((d, i) => {
          d.setup.linkedRuns !== undefined &&
            Object.keys(d.setup.linkedRuns)
              .filter((sId) => d.setup.linkedRuns[sId] !== undefined)
              .forEach((sId) => {
                allocated += Math.round((d.setup.linkedRuns[sId].percentage / 100) * balanceAlloc[sId].total);
                total += balanceAlloc[sId].total;
              });
        });
    }
    return linkedOptimized ? linkedOptimized[oKey] * (allocated / (total || 1)) : 0;
  }

  render() {
    const {
      id,
      isNext,
      approvedScenario,
      isContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      isBalance,
      hasLinkedProject,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      linkedModelGroups,
      linkedProject,
      runId,
      model,
      setMaxBudget,
      setMinBudget,
      updateLinkedProjectId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateHasLinkedProject,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      isLoadingLink,
      history,
      linkedOptimized,
      isChatGPT,
      showBalancerSettings,
      updateShowBalancerSettings
    } = this.props;

    if (hasLinkedProject && isLoadingLink) {
      return this.renderIsLoadingLink();
    }

    const firstSetup = optimized && optimized.first && optimized.first.setup;
    const secondSetup = optimized && optimized.second && optimized.second.setup;

    const { isHammer, isCompare, isDrivers } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const pursued = Number(setup.truePositive) + Number(setup.falsePositive);
    const notPursued = Number(setup.trueNegative) + Number(setup.falseNegative);
    const total = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    const shouldRenderSankey =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues
            .filter((d) => modelGroups.drilldownValues.length === 1 || d.value !== "Overall")
            .reduce(
              (a, b) =>
                a &&
                b.setup &&
                b.setup.linkedRuns !== undefined &&
                Object.keys(b.setup.linkedRuns).reduce(
                  (c, d) => c || (b.setup.linkedRuns[d] && b.setup.linkedRuns[d].linkedRunId !== undefined),
                  false
                ),
              true
            )
        : false;

    return (
      <div
        className={styles.emptyOptimize}
        style={optimized && optimized.isCreating === false && !isChatGPT ? { paddingBottom: "200px" } : {}}
      >
        {isChatGPT === true ? (
          <div />
        ) : isNext !== true ? (
          <div className={styles.emptyTop}>
            <div className={styles.pTitle}>{"Enterprise Resourcing Balancing and Optimization"}</div>
            <div className={styles.eBoxHolder}>
              {optimized && optimized.isCreating === false ? (
                <div className={styles.bBox}>
                  <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                  <div className={styles.eLightLarge}>
                    {optimized.isCurrencyUnitType ? (
                      <div>
                        {unitType}
                        {numeral(optimized.totalCost + this.getScaledLinkedOptimized("totalCost")).format("0.0a")}
                      </div>
                    ) : (
                      <div className={styles.nonC}>
                        {numeral(optimized.totalCost + this.getScaledLinkedOptimized("totalCost")).format("0.0a")}
                        <div className={styles.subLabel}>{unitType}</div>
                      </div>
                    )}
                  </div>
                  {isSkipped !== true ? (
                    <TinyBarChart
                      bars={[
                        {
                          label: "Optimal " + optimized.resourcingLabel,
                          Cost: optimized.totalCost + this.getScaledLinkedOptimized("totalCost")
                        },
                        {
                          label: "Current " + optimized.resourcingLabel,
                          Cost: optimized.currentSpend + this.getScaledLinkedOptimized("currentSpend")
                        }
                      ]}
                      unit={optimized.unitLabel}
                      isCurrencyUnit={optimized.isCurrencyUnitType}
                    />
                  ) : (
                    <div>{"Add baseline assumptions to show difference"}</div>
                  )}
                </div>
              ) : optimized && optimized.isCreating ? (
                <div className={styles.bBox}>
                  <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                  <div className={styles.eLoading}>
                    <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                  </div>
                  {this.renderProgress("Resourcing")}
                </div>
              ) : (
                <div />
              )}
              {optimized && optimized.isCreating === false ? (
                <div className={styles.bFlex} style={{ flexGrow: 1 }}>
                  {this.renderMix()}
                </div>
              ) : optimized && optimized.isCreating ? (
                <div className={styles.bBox} style={{ justifyContent: "flex-start" }}>
                  <div className={styles.eLoading}>
                    <LoadingIndicator
                      style={{
                        margin: "0px",
                        marginTop: "10px"
                      }}
                      color={"#868595"}
                    />
                  </div>
                </div>
              ) : (
                <div
                  className={styles.bBox}
                  style={{
                    justifyContent: "flex-start",
                    whiteSpace: "wrap"
                  }}
                >
                  <div className={styles.eSubDark}>
                    {"Aible will show the optimal resource allocation once the AI has been trained."}
                  </div>
                </div>
              )}
              {optimized && optimized.isCreating === false ? (
                <div className={styles.bBox}>
                  <div className={styles.eDark}>{optimized.profitLabel}</div>
                  <div className={styles.eLightLarge}>
                    {optimized.isCurrencyUnitType ? (
                      <div>
                        {unitType}
                        {numeral(optimized.profit - this.getScaledLinkedOptimized("totalCost")).format("0.0a")}
                      </div>
                    ) : (
                      <div className={styles.nonC}>
                        {numeral(optimized.profit - this.getScaledLinkedOptimized("totalCost")).format("0.0a")}
                        <div className={styles.subLabel}>{unitType}</div>
                      </div>
                    )}
                  </div>
                  {isSkipped !== true ? (
                    <TinyBarChart
                      bars={[
                        {
                          label: "Optimal " + optimized.profitLabel,
                          Cost: optimized.profit - this.getScaledLinkedOptimized("totalCost")
                        },
                        {
                          label: "Current " + optimized.profitLabel,
                          Cost: optimized.currentProfit - this.getScaledLinkedOptimized("currentSpend")
                        }
                      ]}
                      unit={optimized.unitLabel}
                      isCurrencyUnit={optimized.isCurrencyUnitType}
                    />
                  ) : (
                    <div>{"Add baseline assumptions to show difference"}</div>
                  )}
                </div>
              ) : optimized && optimized.isCreating ? (
                <div className={styles.bBox}>
                  <div className={styles.eDark}>{optimized.profitLabel}</div>
                  <div className={styles.eLoading}>
                    <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                  </div>
                  {this.renderProgress(optimized.profitLabel)}
                </div>
              ) : (
                <div />
              )}
            </div>
            {this.renderTopSankey()}
          </div>
        ) : (
          <div className={styles.emptyTop}>
            <div className={styles.pTitle}>{"Enterprise Resourcing Balancing and Optimization"}</div>
            {this.renderTopSankey()}
          </div>
        )}
        <div className={styles.emptyBot}>
          <div className={styles.splitBody} style={{ width: "100%" }}>
            {hasLinkedProject && this.renderAllocationSankey()}
          </div>
          {isChatGPT && (
            <Button
              onClick={() => updateShowBalancerSettings(!showBalancerSettings)}
              style={
                showBalancerSettings === true ? { marginTop: "20px", marginBottom: "16px" } : { marginTop: "20px" }
              }
            >
              {showBalancerSettings === true ? "Hide Balance Settings" : "Configure Balance Settings"}
            </Button>
          )}
          {(isChatGPT !== true || showBalancerSettings === true) && (
            <div className={styles.eBotSplit} ref={(ref) => (this.allocationRef = ref)}>
              {this.renderSplitSetup()}
            </div>
          )}
        </div>
      </div>
    );
  }
}
